// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2cM1z","productName":"Table_productName__8QDbX"};